import { createContext, useContext } from 'react';
import { ContentContextType } from '.';

export const ContentContext = createContext<ContentContextType | null>(null);

export const useContent = () => {
    const context = useContext(ContentContext);
    if (!context) {
        throw new Error('useContent must be used within a ContentProvider');
    }
    return context;
};
